<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="方案名称:" prop="planName">
        <el-input v-model="data.planName" :maxlength="50" placeholder="请输入方案名称" clearable/>
      </el-form-item>
      <el-form-item label="设计者:" prop="designer">
        <el-input v-model="data.designer" :maxlength="20" placeholder="请输入设计者名称" clearable/>
      </el-form-item>
      <el-form-item label="方案描述:" prop="planDesc">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="500" show-word-limit v-model="data.planDesc" placeholder="请输入500字以内" clearable/>
      </el-form-item>
      <el-form-item label="方案附件:" prop="fileUrls">
        <FileUpload v-model="data.fileUrls" :limit="5" :readOnly="false" @on-change="handleFileChange"></FileUpload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>

</template>

<script>
import FileUpload from "@/views/crm/components/fileUpload";
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import { mapState } from 'vuex'
import { changeBusinessPlan, queryBusinessPlanByRelateId } from '@/api/crm/business'

export default {
  name: "addBusinessPlanDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      title: '',
      areaOptions: [],
      rules: {
        planName: [
          {required: true, message: '请输入方案名称', trigger: 'change'},
          {max: 30, message: '长度过长', trigger: 'change'}
        ],
        designer: [
          {required: true, message: '请输入设计者', trigger: 'change'},
          {max: 20, message: '长度过长', trigger: 'change'}
        ],
        planDesc: [
          {required: true, message: '请输入方案描述', trigger: 'change'},
          {max: 500, message: '长度过长', trigger: 'change'}
        ]
      },
      data: {
        id: null,
        businessId: null,
        planName: null,
        designer: null,
        planDesc: null,
        files: null,
        fileObjs: [],
        createBy: null,
        createByName: null,
        createTime: null
      }
    };
  },
  created() {
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    FileUpload,
    CompanyInput
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open (businessId, row) {
      this.data.businessId = businessId;
      this.visible = true;
      if (row) {
        this.title = '编辑方案'
        this.data = row
      } else {
        this.title = '新增方案'
      }
    },
    handleFileChange (fileObjs) {
      this.data.fileObjs = fileObjs;
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          let params = JSON.parse(JSON.stringify(this.data));
          if (params.fileObjs && params.fileObjs.length > 0) {
            params.fileObjs = params.fileObjs.map(item => {
              return { id: item.id };
            })
          }
          changeBusinessPlan(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("操作成功");
            this.$emit(success)
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
